import { defineMessages } from 'react-intl';

export default defineMessages({
  expand: { defaultMessage: 'Expand' },
  collapse: { defaultMessage: 'Collapse' },
});
